import { Redirect } from 'expo-router';

import { IS_PRODUCTION } from '../../../config/FruitfulEnvironment';
import SimulateAcatTransfer from '../../../investment/components/acat-simulation/SimulateAcatTransfer';

const SimulateAcatScreen = () => {
    if (IS_PRODUCTION) {
        return <Redirect href="/home/investment" />;
    }

    return <SimulateAcatTransfer />;
};

export default SimulateAcatScreen;
